<template>
  <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
    <v-form v-bind="this.$attrs">
      <v-row>
        <SelectDateFilter style="width: 50%" @changeDate="dateChange" />
      </v-row>
    </v-form>
    <div class="d-flex flex-wrap justify-end mt-8 flex-gap">
      <v-btn class="ml-6" dark depressed color="#0D47A1" @click="search">
        <v-icon left>mdi-filter</v-icon>Áp dụng</v-btn
      >
    </div>
  </v-card>
</template>
<script>
import SelectDateFilter from '@/modules/import-order/SelectDateFilter.vue'
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  components: { SelectDateFilter },
  data() {
    return {
      date: {
        start: '',
        end: ''
      },
      error: {
        isError: false,
        message: ''
      }
    }
  },
  computed: {
    ...mapState({
      searchQuery(state) {
        return {
          ...state['importDeliveries'].searchQuery,
          status: ['open', 'closed']
        }
      },
      itemsPerPage(state) {
        return state['importDeliveries'].itemsPerPage
      }
    })
  },
  methods: {
    ...mapActions({
      fetchItems: 'importDeliveries/fetchItems',
      fetchStats: 'importDeliveries/fetchStats',
      countItems: 'importDeliveries/countItems'
    }),
    ...mapMutations({
      setSearchQuery: 'importDeliveries/setSearchQuery'
    }),
    async search() {
      const query = {
        ...this.searchQuery,
        scheduledFrom_lte: this.date.end,
        scheduledTo_gte: this.date.start
      }
      await this.fetchItems({ ...query, _start: 0, _limit: this.itemsPerPage })
      await this.fetchStats(query)
      await this.countItems(query)
      this.setSearchQuery(query)
    },
    dateChange(val) {
      this.date = val
    },
    async filter() {}
  }
}
</script>
